// GERADO POR scripts/build-icons.js — não edite à mão.
// Fonte: handoff/assets/icons/icons.json
//
// Mapa oficial: chave de uso -> componente de ícone.
// Imports nomeados de propósito: o pacote lucide tem mais de mil ícones
// e só estes entram no bundle.

import { Activity, Bell, Bike, BookOpen, Bookmark, Calendar, Camera, Check, ChevronDown, ChevronLeft, ChevronRight, ChevronsLeftRight, CircleDot, Clock, Crown, Disc, Droplet, Drumstick, Dumbbell, FileText, Flag, Flame, Footprints, GripVertical, Heart, Hexagon, House, Info, Languages, Leaf, Link, LocateFixed, Lock, LogOut, MapPin, Medal, Menu, MessageCircle, Mic, Moon, Mountain, Package, Pause, Pencil, PersonStanding, Play, Plus, RefreshCw, Repeat, RotateCcw, Rows3, Ruler, Sailboat, Scale, Search, Send, Shield, Smartphone, Snowflake, Sparkles, Square, Star, Target, Ticket, Trash2, TrendingUp, TriangleAlert, Trophy, Upload, User, Users, Utensils, VolumeX, Waves, X, Zap } from 'lucide-react';
import { IconeBall, IconeBread, IconeCoin, IconeEmblemHex, IconeSeloCheck, IconeSeloHex, IconeSeloStar, IconeSneaker } from './custom';

export const ICONES = {
  'tab.inicio': House,
  'tab.dieta': Utensils,
  'tab.camera': Camera,
  'tab.treino': Dumbbell,
  'tab.perfil': User,
  'topbar.coin': Hexagon,
  'topbar.streak': Flame,
  'score.treino': Dumbbell,
  'score.dieta': Utensils,
  'score.corpo': PersonStanding,
  'action.back': ChevronLeft,
  'action.close': X,
  'action.more': ChevronRight,
  'action.expand': ChevronDown,
  'action.share': Upload,
  'action.send': Send,
  'action.add': Plus,
  'action.search': Search,
  'action.settings': Menu,
  'action.bell': Bell,
  'action.messages': Send,
  'action.flash': Zap,
  'action.flip': RefreshCw,
  'action.mic': Mic,
  'action.calendar': Calendar,
  'action.rules': FileText,
  'action.play': Play,
  'action.check': Check,
  'action.info': Info,
  'action.lock': Lock,
  'action.bookmark': Bookmark,
  'action.mute': VolumeX,
  'action.link': Link,
  'action.clock': Clock,
  'action.edit': Pencil,
  'action.sparkles': Sparkles,
  'action.users': Users,
  'post.like': Heart,
  'post.comment': MessageCircle,
  'post.repost': Repeat,
  'post.share': Send,
  'macro.protein': Drumstick,
  'macro.carb': IconeBread,
  'macro.fat': Droplet,
  'modality.musculacao': Dumbbell,
  'modality.caminhada': Footprints,
  'modality.corrida': IconeSneaker,
  'modality.bike': Bike,
  'modality.natacao': Waves,
  'modality.funcional': Activity,
  'modality.hiit': Zap,
  'modality.yoga': Leaf,
  'modality.esportes': IconeBall,
  'camera.refeicao': Utensils,
  'camera.treino': Dumbbell,
  'camera.post': Pencil,
  'level.emblem': IconeEmblemHex,
  'selo.check': IconeSeloCheck,
  'selo.hex': IconeSeloHex,
  'selo.star': IconeSeloStar,
  'coin': IconeCoin,
  'config.account': User,
  'config.notifications': Bell,
  'config.privacy': Shield,
  'config.units': Ruler,
  'config.appearance': Moon,
  'config.idioma': Languages,
  'config.subscription': Crown,
  'config.logout': LogOut,
  'scanbody.camera': Camera,
  'scanbody.bio': Activity,
  'scanbody.manual': Ruler,
  'ticket': Ticket,
  'permission.location': MapPin,
  'caminho.treino': Dumbbell,
  'caminho.descanso': Moon,
  'caminho.aprendizado': BookOpen,
  'caminho.bau': Package,
  'caminho.checkpoint': Camera,
  'caminho.checkpointEdu': FileText,
  'educacao.vida': Heart,
  'educacao.mapa': MapPin,
  'caminho.recuperado': Snowflake,
  'caminho.atualizado': RefreshCw,
  'caminho.estrela': Star,
  'caminho.ordenar': GripVertical,
  'caminho.nivel': Smartphone,
  'caminho.peso': Scale,
  'caminho.medidas': Ruler,
  'caminho.bioimpedancia': Activity,
  'caminho.comparar': ChevronsLeftRight,
  'clube.grupo': Users,
  'clube.desafio': Flag,
  'clube.treinos': Dumbbell,
  'clube.treinosRef': Utensils,
  'clube.vita': Sparkles,
  'clube.minutos': Clock,
  'clube.individual': User,
  'clube.equipes': Users,
  'clube.trofeu': Trophy,
  'clube.medalha': Medal,
  'modality.trilha': Mountain,
  'modality.remo': Sailboat,
  'modality.patins': Disc,
  'atividade.pausa': Pause,
  'atividade.parar': Square,
  'atividade.travar': Lock,
  'atividade.meta': Target,
  'atividade.elevacao': TrendingUp,
  'atividade.splits': Rows3,
  'atividade.recuperada': RotateCcw,
  'atividade.alerta': TriangleAlert,
  'atividade.excluir': Trash2,
  'atividade.recentrar': LocateFixed,
  'atividade.gravar': CircleDot,
};

export default ICONES;
